import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMfaEnable = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#BFC8CB",
		d: "M12 20.962q-3.014-.895-5.007-3.651Q5 14.554 5 11.1V5.692l7-2.615 7 2.615V11.1q0 3.454-1.993 6.21-1.994 2.757-5.007 3.652"
	})
});
export { SvgMfaEnable as ReactComponent };
